import {
  ErrorFormat
} from "./chunk-BSNL3Y5V.mjs";
import {
  Alert
} from "./chunk-JLKXDVVV.mjs";
import {
  init_icons
} from "./chunk-BTTD2DGG.mjs";
import {
  ErrorFilled_default
} from "./chunk-YTKEFUAN.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/components/error-notification/error-notification.tsx
import React from "react";
init_icons();
var ErrorNotification = (_a) => {
  var _b = _a, {
    error
  } = _b, props = __objRest(_b, [
    "error"
  ]);
  if (!error) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Alert, __spreadProps(__spreadValues({}, props), { variant: "critical-subtle", icon: /* @__PURE__ */ React.createElement(ErrorFilled_default, null) }), /* @__PURE__ */ React.createElement(ErrorFormat, { error }));
};

export {
  ErrorNotification
};
